<div class="container-fluid modal">
  <div class="modal-content p-1 position-relative p-4">
    <button type="button" class="close-btn" (click)="cancel.emit()" [attr.aria-label]="'DEVICES_NO' | translate">
      <svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
      </svg>
    </button>
    <div class="row g-0 mt-4">
      <h5 class="popup-title text-center m-0 pb-3">
        {{ "TOKEN_RETRY_QUESTION" | translate }}
      </h5>
      <div class="token-list p-2">
        <div class="token-item p-3" *ngFor="let token of tokens">
          <span class="w-25">
            {{ token.type }}
          </span>

          <span class="flex-grow-1">
            {{ token.value }}
          </span>
          <span class="token-status" [ngClass]="{
                    'status-pending': token.status === 'Pending',
                    'status-completed': token.status === 'Success',
                    'status-failed': token.status === 'Failed',
                  }">
            {{ token.status }}
          </span>
        </div>
      </div>
    </div>
    <div class="row g-0 m-0 d-flex p-3 gap-3">
      <button class="button-style-green col" (click)="retry.emit()">
        {{ "DEVICES_YES" | translate }}
      </button>
      <button class="button-style-red col" (click)="cancel.emit()">
        {{ "DEVICES_NO" | translate }}
      </button>
    </div>
  </div>
</div>
